import { Component, computed, OnDestroy, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as fontawesome from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import {
  SportType,
  SportTypes,
} from '../../../../../shared/constants/sport-type';
import { SportFilterService } from '../../services/sport-filter.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-sport-filter',
  imports: [FontAwesomeModule],
  template: `
    <div
      [class]="
        'fixed p-4 duration-200 transition-all top-full left-0 w-full h-full bg-background z-50 flex flex-col space-y-4 ' +
        (show() ? '!top-0' : '')
      "
    >
      <h2 class="text-center flex-shrink-0 text-dark font-bold text-2xl">Select Sport</h2>
      <div
        class="flex flex-col space-y-2 flex-1 container mx-auto overflow-auto"
      >
        <button
          class="w-full shadow-md py-2 px-4 rounded-md flex items-center text-dark"
          (click)="selectSport('')"
        >
          All @if(sportFilterService.filter() === '') { &nbsp;
          <fa-icon class="text-accent" [icon]="fa.faCheckCircle"></fa-icon>
          }
        </button>
        @for(sportType of sportTypeList; track sportType) {
        <button
          class="w-full shadow-md py-2 px-4 rounded-md flex items-center text-dark"
          (click)="selectSport(sportType)"
        >
          {{ sportType }}
          @if(sportType === sportFilterService.filter()) { &nbsp;
          <fa-icon class="text-accent" [icon]="fa.faCheckCircle"></fa-icon>
          }
        </button>
        }
      </div>
      <div class="flex justify-end flex-shrink-0">
        <button
          class="bg-danger shadow-md text-dangerContrast py-2 px-4 rounded-full"
          (click)="hideSportFilter()"
        >
          Close
        </button>
      </div>
    </div>
  `,
  styles: ``,
})
export class SportFilterComponent implements OnDestroy {
  show = computed(() => this.sportFilterService.show());
  fa = fontawesome;

  sportTypeList = Object.keys(SportTypes).map(
    (key) => (SportTypes as { [key: string]: string })[key]
  );

  private subs = new Subscription();

  constructor(
    private route: ActivatedRoute,
    public sportFilterService: SportFilterService,
    private loc: Location
  ) {
    // this.subs.add(
    //   this.route.queryParams.subscribe((params) => {
    //     const showSportFilter = params['showSportFilter'];
    //     this.showSportFilter.set(showSportFilter === 'true');
    //   })
    // );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  selectSport(sportType: string) {
    this.sportFilterService.filter.set(sportType as SportType);
    this.hideSportFilter();
  }

  hideSportFilter() {
    this.sportFilterService.hideSportFilter();
    // this.loc.back();
  }

  showSportFilter() {
    this.sportFilterService.showSportFilter();
  }
}
